export default __webpack_public_path__ + "static/media/CAP3M-thumbnail-cc.dad24b6f.png";